//--- React
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
//--- Ant Design
import { Col, Row } from "antd";
//--- Project
import { useRequiredAccess } from "hooks/useRequiredAccess";
import { getCompanyReviewCounts, getCompanyReviewPercentages } from "apis/competitorPulseApis";
import { ORG_TYPES } from "components/Common/Constants";
import Reviews from "./Reviews";
import { setPageLoader } from "reducers/loaderSlice";
import CompanyWiseSpread from "./CompanyWiseSpread";
import CategoryWiseSpread from "./CategoryWiseSpread";
import { primaryColor } from "../constants";

const MarketPulseOverview = ({
  onChangeTab,
}) => {
  const dispatch = useDispatch();
  const checkAccess = useRequiredAccess([], [ORG_TYPES.ADMINISTRATOR]);
  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    data: companiesList,
    isLoading: companyDataLoading,
    isError: companyDataIsError,
    error: companyDataError,
  } = useQuery({
    queryKey: ["ReviewPercentages"],
    queryFn: () => getCompanyReviewPercentages(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
  
  const { data: reviewTypeData, isLoading: reviewTypeDataLoading } = useQuery({
    queryKey: ["ReviewCount"],
    queryFn: () => getCompanyReviewCounts(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    dispatch(setPageLoader(reviewTypeDataLoading ? "refresh" : null));
  }, [dispatch, reviewTypeDataLoading]);

  return (
    <Row justify={"center"} className="competitor-pulse-overview h100vh mb1">
      <Col span={24} >
        <Reviews reviewTypeData={reviewTypeData} />
      </Col>
      <Col span={24} className="mt1">
        <CompanyWiseSpread
          selectedColor={primaryColor}
          onChangeTab={onChangeTab}
          companiesList={companiesList}
          companyDataLoading={companyDataLoading}
          companyDataIsError={companyDataIsError}
          companyDataError={companyDataError}
        />
        {/* <CompanyWiseSpread selectedColor={"#A12AA3"} onChangeTab={onChangeTab} /> */}
      </Col>
      <Col span={24} className="mt1">
        <CategoryWiseSpread
          onChangeTab={onChangeTab}
          companiesList={companiesList}
          companiesLoading={companyDataLoading}
        />
      </Col>
    </Row>
  );
};

export default MarketPulseOverview;
